import {
	REPORT_COMPLAINT_CAR_MODEL_FETCH_SUCCESS,
	REPORT_COMPLAINT_CAR_MODEL_FETCH_RESET,
	REPORT_COMPLAINT_CATEGORIES_FETCH_SUCCESS,
	REPORT_COMPLAINT_CATEGORIES_FETCH_RESET,
	REPORT_SURVEY_FETCH_SUCCESS,
	REPORT_SURVEY_FETCH_RESET,
	REPORT_TICKET_FETCH_SUCCESS,
	REPORT_TICKET_FETCH_RESET,
	REPORT_TICKET_3MONTHS_FETCH_SUCCESS,
	REPORT_TICKET_3MONTHS_FETCH_RESET,
	REPORT_TICKET_6MONTHS_FETCH_SUCCESS,
	REPORT_TICKET_6MONTHS_FETCH_RESET,
	REPORT_TICKET_YTD_FETCH_SUCCESS,
	REPORT_TICKET_YTD_FETCH_RESET,
	REPORT_TICKET_SHOWROOM_STATUSES_FETCH_SUCCESS,
	REPORT_TICKET_SHOWROOM_STATUSES_FETCH_RESET,
	REPORT_TICKET_SERVICE_STATUSES_FETCH_SUCCESS,
	REPORT_TICKET_SERVICE_STATUSES_FETCH_RESET,
	REPORT_TICKETS_SHOWROOM_FETCH_SUCCESS,
	REPORT_TICKETS_SHOWROOM_FETCH_RESET,
	REPORT_TICKETS_SERVICE_FETCH_SUCCESS,
	REPORT_TICKETS_SERVICE_FETCH_RESET,
	REPORT_TICKETS_SHOWROOM_FORM_UPDATE,
	REPORT_TICKETS_SERVICE_FORM_UPDATE,
	REPORT_TICKET_HOTSHEET_SHOWROOM_STATUSES_FETCH_SUCCESS,
	REPORT_TICKET_HOTSHEET_SHOWROOM_STATUSES_FETCH_RESET,
	REPORT_TICKET_HOTSHEET_SERVICE_STATUSES_FETCH_SUCCESS,
	REPORT_TICKET_HOTSHEET_SERVICE_STATUSES_FETCH_RESET,
	REPORT_TICKETS_HOTSHEET_SHOWROOM_FETCH_SUCCESS,
	REPORT_TICKETS_HOTSHEET_SHOWROOM_FETCH_RESET,
	REPORT_TICKETS_HOTSHEET_SERVICE_FETCH_SUCCESS,
	REPORT_TICKETS_HOTSHEET_SERVICE_FETCH_RESET,
	REPORT_TICKETS_HOTSHEET_SHOWROOM_FORM_UPDATE,
	REPORT_TICKETS_HOTSHEET_SERVICE_FORM_UPDATE,
	REPORT_TICKET_CALLCENTER_SHOWROOM_STATUSES_FETCH_SUCCESS,
	REPORT_TICKET_CALLCENTER_SHOWROOM_STATUSES_FETCH_RESET,
	REPORT_TICKET_CALLCENTER_SERVICE_STATUSES_FETCH_SUCCESS,
	REPORT_TICKET_CALLCENTER_SERVICE_STATUSES_FETCH_RESET,
	REPORT_TICKETS_CALLCENTER_SHOWROOM_FETCH_SUCCESS,
	REPORT_TICKETS_CALLCENTER_SHOWROOM_FETCH_RESET,
	REPORT_TICKETS_CALLCENTER_SERVICE_FETCH_SUCCESS,
	REPORT_TICKETS_CALLCENTER_SERVICE_FETCH_RESET,
	REPORT_TICKETS_CALLCENTER_SHOWROOM_FORM_UPDATE,
	REPORT_TICKETS_CALLCENTER_SERVICE_FORM_UPDATE,
	REPORT_TICKET_KPI_FETCH_SUCCESS,
	REPORT_TICKET_KPI_FETCH_RESET,
	REPORT_TICKET_KPI_3MONTHS_FETCH_SUCCESS,
	REPORT_TICKET_KPI_3MONTHS_FETCH_RESET,
	REPORT_TICKET_KPI_6MONTHS_FETCH_SUCCESS,
	REPORT_TICKET_KPI_6MONTHS_FETCH_RESET,
	REPORT_TICKET_KPI_YTD_FETCH_SUCCESS,
	REPORT_TICKET_KPI_YTD_FETCH_RESET,
	REPORT_TICKET_KPI_SURVEY_FETCH_SUCCESS,
	REPORT_TICKET_KPI_SURVEY_FETCH_RESET,
	REPORT_RESPONSE_RATE_SHOWROOM_FETCH_SUCCESS,
	REPORT_RESPONSE_RATE_SHOWROOM_FETCH_RESET,
	REPORT_RESPONSE_RATE_SERVICE_FETCH_SUCCESS,
	REPORT_RESPONSE_RATE_SERVICE_FETCH_RESET,
	REPORT_NOTIFY_SHOWROOM_FETCH_SUCCESS,
	REPORT_NOTIFY_SHOWROOM_FETCH_RESET,
	REPORT_NOTIFY_SERVICE_FETCH_SUCCESS,
	REPORT_NOTIFY_SERVICE_FETCH_RESET,
	REPORT_QVOC_KPI_FETCH_SUCCESS,
	REPORT_QVOC_KPI_FETCH_RESET,
	REPORT_TICKET_KPI_ALL_FETCH_SUCCESS,
	REPORT_TICKET_KPI_ALL_FETCH_RESET
} from "../actions/types";

const INIT_STATE = {
	reportQvocKpi: {},
	reportTicketKpiAll: {},
	reportComplaintCarModel: [],
	reportComplaintCategories: [],
	reportSurvey: [],
	reportTicket: {},
	reportTicket3Months: {},
	reportTicket6Months: {},
	reportTicketYtd: {},
	reportTicketShowroomStatuses: {},
	reportTicketServiceStatuses: {},
	reportTicketsShowroom: [],
	reportTicketsService: [],
	reportTicketsShowroomForm: {},
	reportTicketsServiceForm: {},
	reportTicketHotSheetShowroomStatuses: {},
	reportTicketHotSheetServiceStatuses: {},
	reportTicketsHotSheetShowroom: [],
	reportTicketsHotSheetService: [],
	reportTicketsHotSheetShowroomForm: {},
	reportTicketsHotSheetServiceForm: {},
	reportTicketCallCenterShowroomStatuses: {},
	reportTicketCallCenterServiceStatuses: {},
	reportTicketsCallCenterShowroom: [],
	reportTicketsCallCenterService: [],
	reportTicketsCallCenterShowroomForm: {},
	reportTicketsCallCenterServiceForm: {},
	reportTicketKpi: {},
	reportTicketKpi3Months: {},
	reportTicketKpi6Months: {},
	reportTicketKpiYtd: {},
	reportTicketKpiSurvey: {},
	reportResponseRateShowroom: {},
	reportResponseRateService: {},
	reportNotifyShowroom: {},
	reportNotifyService: {},
};

export default (state = INIT_STATE, action) => {
	switch (action.type) {
		case REPORT_COMPLAINT_CAR_MODEL_FETCH_SUCCESS:
			return {
				...state,
				reportComplaintCarModel: action.payload
			};
		case REPORT_COMPLAINT_CAR_MODEL_FETCH_RESET:
			return {
				...state,
				reportComplaintCarModel: []
			};
		case REPORT_COMPLAINT_CATEGORIES_FETCH_SUCCESS:
			return {
				...state,
				reportComplaintCategories: action.payload
			};
		case REPORT_COMPLAINT_CATEGORIES_FETCH_RESET:
			return {
				...state,
				reportComplaintCategories: []
			};
		case REPORT_SURVEY_FETCH_SUCCESS:
			return {
				...state,
				reportSurvey: action.payload
			};
		case REPORT_SURVEY_FETCH_RESET:
			return {
				...state,
				reportSurvey: []
			};
		case REPORT_TICKET_FETCH_SUCCESS:
			return {
				...state,
				reportTicket: action.payload
			};
		case REPORT_TICKET_FETCH_RESET:
			return {
				...state,
				reportTicket: {}
			};
		case REPORT_TICKET_3MONTHS_FETCH_SUCCESS:
			return {
				...state,
				reportTicket3Months: action.payload
			};
		case REPORT_TICKET_3MONTHS_FETCH_RESET:
			return {
				...state,
				reportTicket3Months: {}
			};
		case REPORT_TICKET_6MONTHS_FETCH_SUCCESS:
			return {
				...state,
				reportTicket6Months: action.payload
			};
		case REPORT_TICKET_6MONTHS_FETCH_RESET:
			return {
				...state,
				reportTicket6Months: {}
			};
		case REPORT_TICKET_YTD_FETCH_SUCCESS:
			return {
				...state,
				reportTicketYtd: action.payload
			};
		case REPORT_TICKET_YTD_FETCH_RESET:
			return {
				...state,
				reportTicketYtd: {}
			};
		case REPORT_TICKET_SHOWROOM_STATUSES_FETCH_SUCCESS:
			return {
				...state,
				reportTicketShowroomStatuses: action.payload
			};
		case REPORT_TICKET_SHOWROOM_STATUSES_FETCH_RESET:
			return {
				...state,
				reportTicketShowroomStatuses: {}
			};
		case REPORT_TICKET_SERVICE_STATUSES_FETCH_SUCCESS:
			return {
				...state,
				reportTicketServiceStatuses: action.payload
			};
		case REPORT_TICKET_SERVICE_STATUSES_FETCH_RESET:
			return {
				...state,
				reportTicketServiceStatuses: {}
			};
		case REPORT_TICKETS_SHOWROOM_FETCH_SUCCESS:
			return {
				...state,
				reportTicketsShowroom: action.payload
			};
		case REPORT_TICKETS_SHOWROOM_FETCH_RESET:
			return {
				...state,
				reportTicketsShowroom: []
			};
		case REPORT_TICKETS_SERVICE_FETCH_SUCCESS:
			return {
				...state,
				reportTicketsService: action.payload
			};
		case REPORT_TICKETS_SERVICE_FETCH_RESET:
			return {
				...state,
				reportTicketsService: []
			};
		case REPORT_TICKETS_SHOWROOM_FORM_UPDATE:
			return {
				...state,
				reportTicketsShowroomForm: action.payload
			};
		case REPORT_TICKETS_SERVICE_FORM_UPDATE:
			return {
				...state,
				reportTicketsServiceForm: action.payload
			};
		case REPORT_TICKET_HOTSHEET_SHOWROOM_STATUSES_FETCH_SUCCESS:
			return {
				...state,
				reportTicketHotSheetShowroomStatuses: action.payload
			};
		case REPORT_TICKET_HOTSHEET_SHOWROOM_STATUSES_FETCH_RESET:
			return {
				...state,
				reportTicketHotSheetShowroomStatuses: {}
			};
		case REPORT_TICKET_HOTSHEET_SERVICE_STATUSES_FETCH_SUCCESS:
			return {
				...state,
				reportTicketHotSheetServiceStatuses: action.payload
			};
		case REPORT_TICKET_HOTSHEET_SERVICE_STATUSES_FETCH_RESET:
			return {
				...state,
				reportTicketHotSheetServiceStatuses: {}
			};
		case REPORT_TICKETS_HOTSHEET_SHOWROOM_FETCH_SUCCESS:
			return {
				...state,
				reportTicketsHotSheetShowroom: action.payload
			};
		case REPORT_TICKETS_HOTSHEET_SHOWROOM_FETCH_RESET:
			return {
				...state,
				reportTicketsHotSheetShowroom: []
			};
		case REPORT_TICKETS_HOTSHEET_SERVICE_FETCH_SUCCESS:
			return {
				...state,
				reportTicketsHotSheetService: action.payload
			};
		case REPORT_TICKETS_HOTSHEET_SERVICE_FETCH_RESET:
			return {
				...state,
				reportTicketsHotSheetService: []
			};
		case REPORT_TICKETS_HOTSHEET_SHOWROOM_FORM_UPDATE:
			return {
				...state,
				reportTicketsHotSheetShowroomForm: action.payload
			};
		case REPORT_TICKETS_HOTSHEET_SERVICE_FORM_UPDATE:
			return {
				...state,
				reportTicketsHotSheetServiceForm: action.payload
			};
		case REPORT_TICKET_CALLCENTER_SHOWROOM_STATUSES_FETCH_SUCCESS:
			return {
				...state,
				reportTicketCallCenterShowroomStatuses: action.payload
			};
		case REPORT_TICKET_CALLCENTER_SHOWROOM_STATUSES_FETCH_RESET:
			return {
				...state,
				reportTicketCallCenterShowroomStatuses: {}
			};
		case REPORT_TICKET_CALLCENTER_SERVICE_STATUSES_FETCH_SUCCESS:
			return {
				...state,
				reportTicketCallCenterServiceStatuses: action.payload
			};
		case REPORT_TICKET_CALLCENTER_SERVICE_STATUSES_FETCH_RESET:
			return {
				...state,
				reportTicketCallCenterServiceStatuses: {}
			};
		case REPORT_TICKETS_CALLCENTER_SHOWROOM_FETCH_SUCCESS:
			return {
				...state,
				reportTicketsCallCenterShowroom: action.payload
			};
		case REPORT_TICKETS_CALLCENTER_SHOWROOM_FETCH_RESET:
			return {
				...state,
				reportTicketsCallCenterShowroom: []
			};
		case REPORT_TICKETS_CALLCENTER_SERVICE_FETCH_SUCCESS:
			return {
				...state,
				reportTicketsCallCenterService: action.payload
			};
		case REPORT_TICKETS_CALLCENTER_SERVICE_FETCH_RESET:
			return {
				...state,
				reportTicketsCallCenterService: []
			};
		case REPORT_TICKETS_CALLCENTER_SHOWROOM_FORM_UPDATE:
			return {
				...state,
				reportTicketsCallCenterShowroomForm: action.payload
			};
		case REPORT_TICKETS_CALLCENTER_SERVICE_FORM_UPDATE:
			return {
				...state,
				reportTicketsCallCenterServiceForm: action.payload
			};
		case REPORT_TICKET_KPI_FETCH_SUCCESS:
			return {
				...state,
				reportTicketKpi: action.payload
			};
		case REPORT_TICKET_KPI_FETCH_RESET:
			return {
				...state,
				reportTicketKpi: {}
			};
		case REPORT_TICKET_KPI_3MONTHS_FETCH_SUCCESS:
			return {
				...state,
				reportTicketKpi3Months: action.payload
			}
		case REPORT_TICKET_KPI_3MONTHS_FETCH_RESET:
			return {
				...state,
				reportTicketKpi3Months: {}
			}
		case REPORT_TICKET_KPI_6MONTHS_FETCH_SUCCESS:
			return {
				...state,
				reportTicketKpi6Months: action.payload
			}
		case REPORT_TICKET_KPI_6MONTHS_FETCH_RESET:
			return {
				...state,
				reportTicketKpi6Months: {}
			}
		case REPORT_TICKET_KPI_YTD_FETCH_SUCCESS:
			return {
				...state,
				reportTicketKpiYtd: action.payload
			}
		case REPORT_TICKET_KPI_YTD_FETCH_RESET:
			return {
				...state,
				reportTicketKpiYtd: {}
			}
		case REPORT_TICKET_KPI_SURVEY_FETCH_SUCCESS:
			return {
				...state,
				reportTicketKpiSurvey: action.payload
			}
		case REPORT_TICKET_KPI_SURVEY_FETCH_RESET:
			return {
				...state,
				reportTicketKpiSurvey: {}
			}
		case REPORT_RESPONSE_RATE_SHOWROOM_FETCH_SUCCESS:
			return {
				...state,
				reportResponseRateShowroom: action.payload
			}
		case REPORT_RESPONSE_RATE_SHOWROOM_FETCH_RESET:
			return {
				...state,
				reportResponseRateShowroom: {}
			}
		case REPORT_RESPONSE_RATE_SERVICE_FETCH_SUCCESS:
			return {
				...state,
				reportResponseRateService: action.payload
			}
		case REPORT_RESPONSE_RATE_SERVICE_FETCH_RESET:
			return {
				...state,
				reportResponseRateService: {}
			}
		case REPORT_NOTIFY_SHOWROOM_FETCH_SUCCESS:
			return {
				...state,
				reportNotifyShowroom: action.payload
			}
		case REPORT_NOTIFY_SHOWROOM_FETCH_RESET:
			return {
				...state,
				reportNotifyShowroom: {}
			}
		case REPORT_NOTIFY_SERVICE_FETCH_SUCCESS:
			return {
				...state,
				reportNotifyService: action.payload
			}
		case REPORT_NOTIFY_SERVICE_FETCH_RESET:
			return {
				...state,
				reportNotifyService: {}
			}
		case REPORT_QVOC_KPI_FETCH_SUCCESS:
			return {
				...state,
				reportQvocKpi: action.payload
			}
		case REPORT_QVOC_KPI_FETCH_RESET:
			return {
				...state,
				reportQvocKpi: {}
			}
		case REPORT_TICKET_KPI_ALL_FETCH_SUCCESS:
			return {
				...state,
				reportTicketKpiAll: action.payload
			}
		case REPORT_TICKET_KPI_ALL_FETCH_RESET:
			return {
				...state,
				reportTicketKpiAll: {}
			}
		default:
			return state;
	}
};
